import { reactive } from "vue";


export enum ToastItemType {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR"
}


export interface ToastItem {
    id: number;
    type: ToastItemType;
    title: string;
    value: string;
    timeout: number;
    show: boolean;
}


export const Toast = reactive({

    items: [] as Array<ToastItem>,

    success(title: string, value: string): void {

        this.add(ToastItemType.SUCCESS, title, value);

    },

    error(title: string, value: string): void {

        this.add(ToastItemType.ERROR, title, value);

    },

    add(type: ToastItemType, title: string, value: string): void {

        const id = Date.now();
        
        const timeout = setTimeout(() => {
            this.remove(id);
        }, 10000);

        setTimeout(() => {
            const idx = this.items.findIndex(x => x.id == id);
            if(idx >= 0)
                this.items[idx].show = true;
        }, 100);

        const item: ToastItem = {
            id,
            type,
            title,
            value,
            timeout,
            show: false
        }

        this.items.push(item);

    },

    remove(id: number): void {

        window.clearTimeout(id);
        const idx = this.items.findIndex(x => x.id == id);

        if(idx >= 0) {
            this.items[idx].show = false;

            setTimeout(() => {
                const idx = this.items.findIndex(x => x.id == id);
                if(idx >= 0)
                    this.items.splice(idx, 1);
            }, 200);

        }

    }

})